import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
// Create context with generic parameter
var ThemeContext = React.createContext(null);
// Generic Theme Provider component
export function ThemeProvider(_a) {
    var children = _a.children, theme = _a.theme;
    var containerRef = React.useRef(null);
    var _b = useState(theme), themeObj = _b[0], setTheme = _b[1];
    React.useEffect(function () {
        var container = containerRef.current;
        var themeConfig = theme;
        if (!container)
            return;
        var updateTheme = function () {
            var setThemeProperties = function (obj, prefix) {
                if (prefix === void 0) { prefix = ''; }
                Object.entries(obj).forEach(function (_a) {
                    var key = _a[0], value = _a[1];
                    if (typeof value === 'object' && value !== null) {
                        setThemeProperties(value, "".concat(prefix).concat(key, "-"));
                    }
                    else {
                        container.style.setProperty("--".concat(prefix).concat(key), String(value));
                    }
                });
            };
            setThemeProperties(themeObj);
        };
        updateTheme();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [themeObj, containerRef === null || containerRef === void 0 ? void 0 : containerRef.current]);
    return (_jsx(ThemeContext.Provider, { value: { theme: themeObj, containerRef: containerRef, setTheme: setTheme }, children: _jsx("div", { ref: containerRef, className: 'vas-h-full vas-w-full vas-bg-transparent vas-font-fontFamily', children: children }) }));
}
// Generic hook to use theme
export function useTheme() {
    var context = React.useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
}
